import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { approveProperty, rejectProperty, requestRevision, getPendingProperties } from '../../Redux/Actions/actions';
import style from './ApprovalActions.module.css';

const normalizeUserType = (value) => {
  const v = String(value || '').trim().toUpperCase();
  if (v === 'MARTILLER') return 'MARTILLER';
  if (v === 'SELLER' || v === 'VENDEDOR') return 'SELLER';
  return 'SELLER';
};

const ApprovalActions = ({ propertyId, onActionComplete }) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.userId);
  const user = useSelector((state) => state.user);
  const userType = useSelector((state) => state.userType);
  const versioningLoading = useSelector((state) => state.versioningLoading);
  const [activeModal, setActiveModal] = useState(null); // 'approve' | 'reject' | 'revision'
  const [mensaje, setMensaje] = useState('');

  const currentUserId = user?.user?.id || userId || null;
  const currentUserType = normalizeUserType(user?.user?.type || user?.type || userType);

  const handleApprove = async () => {
    try {
      await dispatch(approveProperty(propertyId, {
        autorTipo: currentUserType,
        autorId: currentUserId,
        ...(currentUserType === 'SELLER' ? { sellerId: currentUserId } : {}),
        mensaje: mensaje.trim() || 'Propiedad aprobada',
      }));
      alert('Propiedad aprobada correctamente.');
      setActiveModal(null);
      setMensaje('');
      dispatch(getPendingProperties());
      if (onActionComplete) onActionComplete();
    } catch {
      alert('Error al aprobar la propiedad.');
    }
  };

  const handleReject = async () => {
    if (!mensaje.trim()) {
      alert('Debe ingresar un motivo para rechazar.');
      return;
    }
    try {
      await dispatch(rejectProperty(propertyId, {
        autorTipo: currentUserType,
        autorId: currentUserId,
        ...(currentUserType === 'SELLER' ? { sellerId: currentUserId } : {}),
        mensaje: mensaje.trim(),
      }));
      alert('Propiedad rechazada. Se notificará al agente.');
      setActiveModal(null);
      setMensaje('');
      dispatch(getPendingProperties());
      if (onActionComplete) onActionComplete();
    } catch {
      alert('Error al rechazar la propiedad.');
    }
  };

  const handleRevision = async () => {
    if (!mensaje.trim()) {
      alert('Debe ingresar instrucciones para la revisión.');
      return;
    }
    try {
      await dispatch(requestRevision(propertyId, {
        autorTipo: currentUserType,
        autorId: currentUserId,
        ...(currentUserType === 'SELLER' ? { sellerId: currentUserId } : {}),
        mensaje: mensaje.trim(),
      }));
      alert('Revisión solicitada al agente.');
      setActiveModal(null);
      setMensaje('');
      dispatch(getPendingProperties());
      if (onActionComplete) onActionComplete();
    } catch {
      alert('Error al solicitar la revisión.');
    }
  };

  const openModal = (type) => {
    setActiveModal(type);
    setMensaje('');
  };

  const closeModal = () => {
    setActiveModal(null);
    setMensaje('');
  };

  return (
    <div className={style.container}>
      <div className={style.buttonRow}>
        <button
          className={style.approveBtn}
          onClick={() => openModal('approve')}
          disabled={versioningLoading}
        >
          ✓ Aprobar
        </button>
        <button
          className={style.rejectBtn}
          onClick={() => openModal('reject')}
          disabled={versioningLoading}
        >
          ✕ Rechazar
        </button>
        <button
          className={style.revisionBtn}
          onClick={() => openModal('revision')}
          disabled={versioningLoading}
        >
          ↻ Solicitar Revisión
        </button>
      </div>

      {activeModal && (
        <div className={style.modal}>
          <div className={style.modalContent}>
            <h4 className={style.modalTitle}>
              {activeModal === 'approve' && 'Aprobar Propiedad'}
              {activeModal === 'reject' && 'Rechazar Propiedad'}
              {activeModal === 'revision' && 'Solicitar Revisión'}
            </h4>
            <textarea
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
              placeholder={
                activeModal === 'approve'
                  ? 'Mensaje de aprobación (opcional)'
                  : activeModal === 'reject'
                  ? 'Motivo del rechazo (obligatorio)'
                  : 'Instrucciones de revisión (obligatorio)'
              }
              className={style.modalTextarea}
              rows={3}
              required={activeModal !== 'approve'}
            />
            <div className={style.modalActions}>
              <button className={style.cancelBtn} onClick={closeModal}>
                Cancelar
              </button>
              <button
                className={
                  activeModal === 'approve' ? style.confirmApprove :
                  activeModal === 'reject' ? style.confirmReject :
                  style.confirmRevision
                }
                onClick={
                  activeModal === 'approve' ? handleApprove :
                  activeModal === 'reject' ? handleReject :
                  handleRevision
                }
                disabled={versioningLoading}
              >
                {versioningLoading ? 'Procesando...' : 'Confirmar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApprovalActions;
